import { Field, FieldLabel } from '@playbooks/ui/components/field';
import { Input } from '@playbooks/ui/components/input';

const RegisterFields = ({ user, setUser }) => {
	// Render
	return (
		<>
			<Field>
				<FieldLabel>Full Name</FieldLabel>
				<Input
					size='lg'
					value={user.name || ''}
					placeholder='Full name'
					onChange={e => setUser({ ...user, name: e.target.value })}
				/>
			</Field>

			<Field>
				<FieldLabel>Email Address</FieldLabel>
				<Input
					size='lg'
					value={user.email || ''}
					placeholder='Email address'
					onChange={e => setUser({ ...user, email: e.target.value })}
				/>
			</Field>

			<Field>
				<FieldLabel>Password</FieldLabel>
				<Input
					size='lg'
					type='password'
					value={user.password || ''}
					placeholder='••••••••'
					onChange={e => setUser({ ...user, password: e.target.value })}
				/>
			</Field>
		</>
	);
};

export { RegisterFields };
